import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarDays, Loader2, Mail, BellRing } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WeeklyDigestPanel = () => {
  const [digests, setDigests] = useState([]);
  const [running, setRunning] = useState(false);
  const [remindRunning, setRemindRunning] = useState(false);

  const load = async () => {
    try {
      const res = await axios.get(`${API}/admin/agents/weekly-digests`, { withCredentials: true });
      setDigests(res.data || []);
    } catch { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const runNow = async () => {
    setRunning(true);
    try {
      const res = await axios.post(`${API}/admin/agents/weekly-digest`, {}, { withCredentials: true });
      setDigests((prev) => [res.data, ...prev]);
      toast.success('Rapport hebdomadaire envoyé par email');
    } catch { toast.error("Erreur lors de l'envoi du rapport"); }
    finally { setRunning(false); }
  };

  const runReminders = async () => {
    setRemindRunning(true);
    try {
      const res = await axios.post(`${API}/admin/agents/pending-applications`, {}, { withCredentials: true });
      toast.success(res.data.message);
    } catch { toast.error('Erreur lors de la relance'); }
    finally { setRemindRunning(false); }
  };

  const latest = digests[0];
  const s = latest?.stats;

  return (
    <Card data-testid="weekly-digest-panel">
      <CardHeader className="flex flex-row items-center justify-between gap-4 flex-wrap">
        <div>
          <CardTitle className="font-heading text-lg flex items-center gap-2"><CalendarDays className="w-5 h-5 text-[#1E3A8A]" /> Rapport hebdomadaire admin</CardTitle>
          <p className="text-xs text-[#6B7280] mt-1">Envoyé chaque lundi matin : inscrits, chantiers, candidatures, support et idées des 7 derniers jours</p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <Button size="sm" variant="outline" onClick={runReminders} disabled={remindRunning} data-testid="run-pending-reminders-btn">
            {remindRunning ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <BellRing className="w-4 h-4 mr-1" />} Relancer candidatures sans réponse
          </Button>
          <Button size="sm" className="bg-[#1E3A8A]" onClick={runNow} disabled={running} data-testid="run-weekly-digest-btn">
            {running ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Mail className="w-4 h-4 mr-1" />} {running ? 'Envoi…' : 'Envoyer le rapport maintenant'}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {!latest ? (
          <p className="text-sm text-[#6B7280]" data-testid="digest-no-report">Aucun rapport envoyé pour le moment. Le premier partira lundi prochain ou manuellement.</p>
        ) : (
          <div className="space-y-3" data-testid="digest-latest">
            <p className="text-sm text-[#4B5563]">Dernier rapport : {new Date(latest.created_at).toLocaleString('fr-FR')} ({latest.trigger === 'manual' ? 'manuel' : 'planifié'}) · période {s.since} → {s.until} · email {latest.email_status}</p>
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 text-center">
              {[['Inscrits', s.new_users], ['Chantiers', s.new_jobs], ['Candidatures', s.new_applications], ['Support', s.support_requests], ['Idées', s.new_suggestions], ['Messages', s.messages]].map(([l, v]) => (
                <div key={l} className="p-2 rounded-md bg-[#F9FAFB]" data-testid={`digest-kpi-${l.toLowerCase()}`}>
                  <p className="text-lg font-bold text-[#1E3A8A]">{v}</p>
                  <p className="text-[10px] text-[#6B7280]">{l}</p>
                </div>
              ))}
            </div>
            {digests.length > 1 && (
              <div className="text-xs text-[#6B7280] flex flex-wrap gap-2 items-center">
                Historique : {digests.slice(1, 7).map((d) => <Badge key={d.id} variant="outline">{d.week}</Badge>)}
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
